module.exports = __webpack_public_path__ + "img/lg_ring_y_i_null_0@2x.18010b88.png";